import React from "react";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import "../styles/domain-pages.css";

export default function ContactPage() {
  return (
    <div className="site-page contact-page">
      <Seo
        title="Contact Data Apparatus | Data Platform Review"
        description="Contact Data Apparatus to discuss data engineering, financial services data, sustainability reporting, industrial operations data, energy data, Power BI reporting and integration work."
      />
      <ContactSection />
      <Footer />
    </div>
  );
}
